import { API } from "@aws-amplify/api";

export const getContact = `query MyQuery($input:cidInput) {
    getContacts(input:$input) {
    contacts {
    name
    phoneNumber
    }
    title
    }
    }`;



export async function getContactDetails(customerId:any): Promise<any> {
  try {
//return responseObject;
const response: any = await API.graphql({ query: getContact, variables: {input:{customerId:customerId} } });
console.log(response)
   return response.data.getContacts
  } catch (error) {
    console.log("get Contact Details", error);
  }
}